module.exports = __webpack_public_path__ + "img/u1188.4fede05f.svg";